'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FACEBOOK_API_KEY = exports.FACEBOOK_API_KEY = '438110309864469';
var GOOGLE_API_KEY = exports.GOOGLE_API_KEY = '799869652051-r3kv5fsn9q8n6322am8cl166praf9u0l.apps.googleusercontent.com';
var EDUREKA_URL = exports.EDUREKA_URL = 'https://resume.hiration.com';
// export const TARGET_URL = 'http://localhost:8000/dieu';
var TARGET_URL = exports.TARGET_URL = 'https://www.hiration.com/dieu';
// export const TARGET_URL = 'http://13.126.214.103/dieu';

// export const TARGET_URL = 'https://onlinetyari.hiration.com';


//////////////////
// WEBPACK FOOTER
// ./src/local_constants.js
// module id = 1767
// module chunks = 0